var _path, _path2, _circle, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 448,
    viewBox: "0 0 448 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.786 356.439C164.562 356.439 105.202 297.079 105.202 223.855C105.202 150.63 164.562 91.2705 237.786 91.2705C311.01 91.2705 370.37 150.63 370.37 223.855C370.37 297.079 311.01 356.439 237.786 356.439ZM237.786 290.147C201.174 290.147 171.494 260.467 171.494 223.855C171.494 187.243 201.174 157.563 237.786 157.563C274.398 157.563 304.078 187.243 304.078 223.855C304.078 260.467 274.398 290.147 237.786 290.147Z",
    fill: "url(#paint0_linear_95_62)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.428 384.351H234.297C243.932 384.351 251.742 376.541 251.742 366.906V80.8034C251.742 71.1687 243.932 63.3582 234.297 63.3582H230.823C181.883 63.3582 137.4 91.7832 116.839 136.194L70.2149 236.903C67.0034 243.839 72.0694 251.767 79.7135 251.767H101.713V314.57C101.713 326.132 111.085 335.505 122.647 335.505H164.516C170.297 335.505 174.983 340.191 174.983 345.972V366.906C174.983 376.541 182.793 384.351 192.428 384.351Z",
    fill: "#6E44FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.3796,
    cy: 38.3796,
    r: 38.3796,
    transform: "matrix(-1 0 0 1 276.166 185.475)",
    fill: "#6E44FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4672,
    cy: 10.4672,
    r: 10.4672,
    transform: "matrix(-1 0 0 1 140.092 175.008)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M354.327 169.775C358.356 162.796 368.428 162.796 372.457 169.775L390.587 201.176C394.616 208.154 389.579 216.877 381.522 216.877H345.263C337.205 216.877 332.169 208.154 336.198 201.176L354.327 169.775Z",
    fill: "url(#paint1_linear_95_62)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M354.327 277.935C358.356 284.913 368.428 284.913 372.457 277.935L390.587 246.534C394.616 239.556 389.579 230.833 381.522 230.833H345.263C337.205 230.833 332.169 239.556 336.198 246.534L354.327 277.935Z",
    fill: "url(#paint2_linear_95_62)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.852 223.855C216.852 235.417 226.224 244.789 237.786 244.789C241.195 244.789 244.413 243.975 247.258 242.529C252.049 240.094 249.196 234.322 243.821 234.322H241.275C239.348 234.322 237.786 232.76 237.786 230.833C237.786 228.906 239.348 227.344 241.275 227.344H254.926C256.949 227.344 258.72 225.878 258.72 223.855C258.72 212.293 249.348 202.921 237.786 202.921C234.377 202.921 231.158 203.735 228.314 205.181C223.523 207.616 226.376 213.388 231.75 213.388H234.297C236.224 213.388 237.786 214.95 237.786 216.877C237.786 218.804 236.224 220.366 234.297 220.366H220.646C218.623 220.366 216.852 221.832 216.852 223.855Z",
    fill: "#FB9C46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M206.384 126.161C206.384 131.714 204.179 137.038 200.253 140.964C196.327 144.89 191.002 147.096 185.45 147.096C179.898 147.096 174.573 144.89 170.647 140.964C166.721 137.038 164.516 131.714 164.516 126.161",
    stroke: "#FB9C46",
    strokeWidth: 6.97812,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M185.45 119.183C185.45 113.631 187.656 108.306 191.582 104.38C195.508 100.454 200.832 98.2488 206.384 98.2488C211.937 98.2488 217.261 100.454 221.187 104.38C225.113 108.306 227.319 113.631 227.319 119.183",
    stroke: "#FB9C46",
    strokeWidth: 6.97812,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M221.213 338.558C221.213 342.171 224.142 345.1 227.755 345.1C231.368 345.1 234.297 342.171 234.297 338.558C234.297 334.945 231.368 332.016 227.755 332.016C224.142 332.016 221.213 334.945 221.213 338.558Z",
    fill: "url(#paint3_linear_95_62)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M221.213 360.364C221.213 363.977 224.142 366.906 227.755 366.906C231.368 366.906 234.297 363.977 234.297 360.364C234.297 356.751 231.368 353.822 227.755 353.822C224.142 353.822 221.213 356.751 221.213 360.364Z",
    fill: "url(#paint4_linear_95_62)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M205.948 366.906C202.335 366.906 199.406 363.977 199.406 360.364C199.406 356.751 202.335 353.822 205.948 353.822C209.561 353.822 212.49 356.751 212.49 360.364C212.49 363.977 209.561 366.906 205.948 366.906Z",
    fill: "url(#paint5_linear_95_62)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_95_62",
    x1: 173.238,
    y1: 223.855,
    x2: 370.37,
    y2: 223.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_95_62",
    x1: 391.305,
    y1: 218.621,
    x2: 300.672,
    y2: 229.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB9C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_95_62",
    x1: 391.305,
    y1: 218.621,
    x2: 300.672,
    y2: 229.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB9C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_95_62",
    x1: 199.406,
    y1: 332.016,
    x2: 209.913,
    y2: 373.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB9C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_95_62",
    x1: 199.406,
    y1: 332.016,
    x2: 209.913,
    y2: 373.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB9C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_95_62",
    x1: 199.406,
    y1: 332.016,
    x2: 209.913,
    y2: 373.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9C46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB9C46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImg);
export default __webpack_public_path__ + "static/media/about-img.e891f5253d0dec299735d5d3b568fb21.svg";
export { ForwardRef as ReactComponent };